<template>
  <vs-dropdown>
    <vs-button
      :color="activeLink ? 'primary' : 'dark'"
      :type="activeLink ? 'filled' : 'border'"
      :size="size" icon-pack="feather"
      :icon="icon">
      {{ title }}
    </vs-button>

    <vs-dropdown-menu>
      <vs-dropdown-item v-for="(menu, key) in menus" :key="key" @click.prevent="navigate(menu.route)">{{ menu.title }}</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  name: 'NestedMenuTabDropDown',
  props: {
    route: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    size: {
      type: String,
      default: 'small'
    },
    menus: {
      type: Array,
      required: true
    }
  },
  computed: {
    currentRoute () {
      return this.$store.getters.currentRoute
    },
    activeLink () {
      return this.currentRoute.name && this.currentRoute.name.includes(this.route)
    }
  },
  methods: {
    navigate (route) {
      this.$router.push({ name: route })
    }
  }
}
</script>

<style scoped>

</style>
